import React from "react";

const StudentProfileHeader = ({
  fullName,
  formData,
  student,
  studentAge,
  studentPhotoInputRef,
  handlePhotoUpload,
  handleSaveStudent,
  saving,
  actionBtnStyle,
  badgeStyle,
  photoCircleStyle,
}) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        gap: 18,
        alignItems: "center",
        background: "#fff",
        border: "1px solid var(--border, #eee)",
        borderRadius: 18,
        padding: "16px 18px",
        boxShadow: "0 6px 18px rgba(0,0,0,0.04)",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "92px minmax(0, 1fr)",
          gap: 16,
          alignItems: "center",
          minWidth: 0,
        }}
      >
        <div style={{ display: "grid", justifyItems: "center", gap: 8 }}>
          <div
            style={{
              ...photoCircleStyle,
              width: 92,
              height: 92,
              background: "#f3f4f6",
            }}
            onClick={() => studentPhotoInputRef.current?.click()}
            title="Upload student photo"
          >
            {formData?.photo || student?.photo ? (
              <img
                src={formData.photo || student?.photo || ""}
                alt="Student"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              fullName?.[0] || "S"
            )}
          </div>

          <div
            style={{
              fontSize: ".88rem",
              color: "var(--text-secondary, #667085)",
              fontWeight: 600,
              cursor: "pointer",
            }}
            onClick={() => studentPhotoInputRef.current?.click()}
          >
            Add Photo
          </div>

          <input
            ref={studentPhotoInputRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => handlePhotoUpload("student", e.target.files?.[0])}
          />
        </div>

        <div
          style={{
            display: "grid",
            gap: 8,
            minWidth: 0,
            alignContent: "start",
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: "2.15rem",
              fontWeight: 900,
              lineHeight: 1.05,
              color: "var(--text, #111827)",
            }}
          >
            {fullName}
          </h1>

          <div
            style={{
              color: "var(--text-secondary, #667085)",
              fontSize: "1rem",
              fontWeight: 500,
            }}
          >
            {[formData?.teacher, formData?.room, `Age ${studentAge}`]
              .filter(Boolean)
              .join(" • ")}
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            {!!(formData?.allergySelections || []).length && (
              <span
                style={{
                  padding: "6px 10px",
                  borderRadius: 999,
                  background: "#fef2f2",
                  color: "#b91c1c",
                  fontWeight: 800,
                  fontSize: ".82rem",
                }}
              >
                Allergy Alert
              </span>
            )}

            {!!(formData?.medications || "").trim() && (
              <span
                style={{
                  padding: "6px 10px",
                  borderRadius: 999,
                  background: "#eff6ff",
                  color: "#1d4ed8",
                  fontWeight: 800,
                  fontSize: ".82rem",
                }}
              >
                Medication on File
              </span>
            )}

            {!!(formData?.disabilitySupportTags || []).length && (
              <span
                style={{
                  padding: "6px 10px",
                  borderRadius: 999,
                  background: "#f5f3ff",
                  color: "#6d28d9",
                  fontWeight: 800,
                  fontSize: ".82rem",
                }}
              >
                Support Plan
              </span>
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gap: 10,
          justifyItems: "end",
          alignContent: "start",
        }}
      >
        <div style={badgeStyle}>{formData?.status || "—"}</div>

        <button
          type="button"
          onClick={handleSaveStudent}
          disabled={saving}
          style={{
            ...actionBtnStyle,
            background: "#fff",
          }}
        >
          {saving ? "Saving..." : "Save Student Profile"}
        </button>
      </div>
    </div>
  );
};

export default StudentProfileHeader;